import { Col } from '../col';
import { Section } from '../form';
import { FormActions } from '../form/form-actions';
import { Modal } from '../modal';
import { Row } from '../row';
import Steps from './stepper-steps';

type P = {
  currentStep: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  getStep: (step: number) => any;
  hideSteps?: boolean;
  numberOfSteps: number;
  onNavigateTo: (step: number) => void;
  onRequestReturn?: () => void;
  onSubmit?: (step: number) => void;
};

const Stepper = ({ currentStep, getStep, hideSteps, numberOfSteps, onNavigateTo, onRequestReturn, onSubmit }: P) => {
  const renderBody = () =>
    [...Array.from({ length: currentStep + 1 }).keys()].map((renderStep) => (
      <div className={renderStep === currentStep ? undefined : 'step__inactive'} key={`render-step-${renderStep}`}>
        {getStep(renderStep)}
      </div>
    ));

  const onChangeStep = (step: number) => {
    onNavigateTo(Math.max(0, Math.min(currentStep, step)));
  };

  const onBackPressed = () => {
    if (currentStep === 0 && onRequestReturn) {
      onRequestReturn();
    } else {
      onNavigateTo(Math.max(currentStep - 1, 0));
    }
  };

  const onNextPressed = onSubmit
    ? () => {
        onSubmit(currentStep);
      }
    : undefined;

  const renderLeft = () => {
    if (currentStep === 0) {
      if (onRequestReturn) {
        return {
          onClick: onRequestReturn,
        };
      }
    } else if (currentStep > 0) {
      return {
        onClick: onBackPressed,
      };
    } else {
      return undefined;
    }

    return undefined;
  };

  return (
    <div className="stepper">
      <Row gutter={[0, 'lg']}>
        {hideSteps ? null : (
          <Col span={24}>
            <Section paddingTop={false}>
              <Steps currentStep={currentStep} numberOfSteps={numberOfSteps} onChange={onChangeStep} />
            </Section>
          </Col>
        )}

        <Col span={24}>{renderBody()}</Col>
      </Row>

      {onNextPressed ? (
        <Modal.HugContent.Footer>
          <FormActions
            right={renderLeft()}
            submit={{
              children: currentStep + 1 < numberOfSteps ? 'Continue' : 'Finish & Publish',
              htmlType: 'button',
              onClick: onNextPressed,
            }}
          />
        </Modal.HugContent.Footer>
      ) : null}
    </div>
  );
};

export default Stepper;
